import graphql from 'babel-plugin-relay/macro';

export const relatedOfferFragment = graphql`
  fragment RelatedOfferFragment on BaseOfferDetail @relay(plural: true) {
    id
    description
    name
    contentKey
    productType
    price {
      priceType
      frequency {
        period
        value
      }
      basePrice
      basePriceExcludingTax
    }
    entitlements {
      name
      shortDescription
      longDescription
      iconUrl
      sortOrder
      contentKey
    }
    promotions {
      name
      shortDescription
      longDescription
      productType
      sortOrder
      contentKey
      iconUrl
    }
    contractTerm {
      name
    }
    productCharacteristics {
      balanceManagement
      offerEligibilityLevel
      relatedOfferId
      relatedOfferIds
    }
    category {
      id
    }
    dataLayerCategory
  }
`;
